/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.messages-filled\":\"Snakkeboble med smilefjes\"}");